/* PHONE_FIRST × PRODUCT journey — thin route shell (Phase 4 §4.1). */

import { usePhoneFirstCheckoutScreen } from './hooks/usePhoneFirstCheckoutScreen.js';
import { PhoneFirstCheckoutScreenView } from './components/phone-first-checkout/PhoneFirstCheckoutScreenView.js';

export type { ProductPaymentRailUiStep } from './phoneFirstProductCheckoutUtils.js';

export function PhoneFirstProductJourney(): JSX.Element {
  return <PhoneFirstCheckoutScreenView {...usePhoneFirstCheckoutScreen()} />;
}
